'use strict';

angular.module('schoolbushubApp')
	.controller('VehicleAuditDeleteController', function($scope, $uibModalInstance, entity, VehicleAudit) {

        $scope.vehicleAudit = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            VehicleAudit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });
